module.exports = __webpack_public_path__ + "static/media/0013.90ab7a71.png";